import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FieldArray } from 'react-final-form-arrays';
import {
  isEqual,
} from 'lodash';
import {
  Accordion,
} from '@folio/stripes/components';

import { Asterisk } from '../../../../../../components/common';
import {
  TEAM_FIELDS,
} from '../../../../../../constants';
import { AssignUserList } from './components';

const validate = (values) => {
  const errorArray = [];

  if (!values.length) {
    // The error is not shown and we need just the fact of the error to disable save
    return errorArray.push({ members: '' });
  }

  return errorArray;
};

const AssignUsers = () => {
  const onAddUsers = (addUser, members) => (users) => (
    users.forEach((user) => {
      const userExist = members.some(el => el.id === user.id);

      if (!userExist) addUser(user);
    })
  );

  const onDeleteUser = (deleteUser, members) => (userToDelete) => {
    const userIndex = members.findIndex((user) => user.id === userToDelete.id);

    deleteUser(userIndex);
  };

  const getAccordionLabel = () => (
    <>
      <FormattedMessage id="ui-task-list.title.accordion.assignUsers" />
      <Asterisk />
    </>
  );

  return (
    <Accordion
      id="assignedUsers"
      label={getAccordionLabel()}
    >
      <FieldArray
        isEqual={isEqual}
        name={TEAM_FIELDS.MEMBERS}
        subscription={{ submitting: true, pristine: true, value: true }}
        validate={validate}
      >
        {({ fields }) => (
          <AssignUserList
            members={fields.value}
            addUser={onAddUsers(fields.push, fields.value)}
            deleteUser={onDeleteUser(fields.remove, fields.value)}
          />
        )}
      </FieldArray>
    </Accordion>
  );
};

export default AssignUsers;
